import React from 'react'

import {
  buildNineSegmentsData,
  type NineSegmentsData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand } from '~/hooks/useSurveyQuery'
import { type NineSegmentCounts } from '~/utils'

import { useNineSegmentsTotalData } from './useNineSegmentsTotalData'

export const useGetNineSegmentsData = (brand: Brand) => {
  const totalData = useNineSegmentsTotalData(brand)

  return React.useCallback(
    (nineSegmentCounts: NineSegmentCounts, total: number): NineSegmentsData =>
      buildNineSegmentsData({
        nineSegmentCounts,
        total,
        totalDataCounts: totalData.counts,
      }),
    [totalData.counts],
  )
}
